module.exports = "<div>\n  <h3 class=\"center\">Propriétaires et wagons</h3>\n\n  <my-owner-pie></my-owner-pie>\n\n  <h3 class=\"center\">Occupation des zones</h3>\n\n  <my-area-pie></my-area-pie>\n\n  <h3 class=\"center\">Mouvements</h3>\n\n  <my-movements-pie></my-movements-pie>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/stat/templates/home.html
// module id = 1541
// module chunks = 0